// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2DzP9","footerMenu":"_2gn7P","Menu":"_1uU02","footerItem":"_1ZWJq","leftSide":"vjfrm","greyText":"_34wFb","yellowText":"_4exH_","footerMenuWrapper":"_1nQmm"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/Footer/Footer.less
// module id = 642
// module chunks = 0